'use client';

import React, { Component } from 'react';
import './style.sass';

import Team from '../reusable-components/layouts-components__zkhfoundation/team';
import Results from '../reusable-components/layouts-components__zkhfoundation/results';
import Process from '../reusable-components/layouts-components__zkhfoundation/process';
import Complex from '../reusable-components/layouts-components__zkhfoundation/complex';
import Tasks from '../reusable-components/layouts-components__zkhfoundation/tasks';
import Goals from '../reusable-components/layouts-components__zkhfoundation/goals';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import { getAdjacentCase } from '../../../../../shared/utilities/GetAdjacentCase/getAdjacentCase';

import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';

import CommonSmallTitle from '../common-components/common-small-title';
import CommonSmallText from '../common-components/common-small-text';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';

const gensMainTitle = {
    titleMainText: `Комплексная работа по&nbsp;обновлению бренда Фонда ЖКХ`,
    titleAnimation: '/images/pic/preview/zkhfoundation.png',
    subtitleContainer: [
        {
            modeText: 'клиент',
            colorMode: '#00529d',
            nameText: 'ГК&nbsp;Фонд содействия реформированию ЖКХ',
        },
        {
            modeText: 'Отрасль',
            colorMode: '#00529d',
            nameText: 'Государственный сектор',
        },
        {
            modeText: 'Услуги',
            colorMode: '#00529d',
            nameText:
                'Ребрендинг, редизайн, разработка, смена системы управления, разработка презентаций и&nbsp;инфографиков, создание видеоролика, SEO',
        },
        {
            modeText: 'Технологии',
            colorMode: '#00529d',
            nameText: 'Битрикс, PHP',
        },
    ],
};

class ZKHFoundation extends Component {
    render() {
        const casePathname = '/cases/development/zkhfoundation';
        const adjacentCase = getAdjacentCase(casePathname);

        return (
            <section className="zkhfoundation">
                <MainTitle MainTitle={gensMainTitle}>
                    <CommonSmallTitle className="zkhfoundation__subtitle">
                        Фонд содействия реформированию жилищно-коммунального хозяйства
                    </CommonSmallTitle>
                    <CommonSmallText>
                        Это государственный фонд, который отвечает за&nbsp;реформирование ЖКХ
                        в&nbsp;России: переселение граждан из&nbsp;аварийного жилья, модернизацию
                        коммунальной инфраструктуры, энергоэффективный капремонт, а&nbsp;также ведет
                        контрольную деятельность, мониторинг рег.систем капремонта, отвечает
                        за&nbsp;просвещение граждан и&nbsp;подготовку кадров. Еще фонд ЖКХ
                        осуществляет деятельность по&nbsp;оздоровлению Волги, очищению воды
                        и&nbsp;улучшению экологии в&nbsp;России.
                    </CommonSmallText>
                </MainTitle>

                <Goals />

                <Tasks />

                <Complex />

                <Process />

                <Results />

                <Team />

                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>

                {adjacentCase && (
                    <NextProject
                        NextProject={{
                            nextProjectTitle: adjacentCase.case.title,
                            nextProjectImg: adjacentCase.case.image,
                            nextProjectLink: adjacentCase.case.router,
                            nextProjectText: adjacentCase.case.description,
                            nextProjectLabel: adjacentCase.label,
                        }}
                    />
                )}
            </section>
        );
    }
}

export default ZKHFoundation;
